import { getBlockCalendarEnabled } from '../selectors/getStoreProperties';
/**
 * Utility function to get create oof event status
 * @returns oof event enabled or disabled status of type boolean
 */
export default function getCreateOofEventStatus() {
    return getBlockCalendarEnabled();
}
//# sourceMappingURL=getCreateOofEventStatus.js.map